var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Elo24 = function Elo24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.02 6.025A9.955 9.955 0 0 1 22 12c0 5.522-4.478 10-10 10S2 17.522 2 12C2 6.477 6.478 2 12 2a9.988 9.988 0 0 1 8.02 4.025z",
    fill: "#050013"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.703 9.32a3.074 3.074 0 0 1 2.988 2.35l-1.238.543v-.003l-1.268.557-3.04 1.328a3.074 3.074 0 0 1 2.56-4.776h-.002zm1.32 1.91-3.07 1.323a1.758 1.758 0 0 1 3.07-1.322v-.001zm.828 3.361c-1.101 1.044-2.556 1.146-3.835.37l.722-1.099c.728.435 1.46.364 2.194-.211l.92.94zm1.25-.761-.007-5.81h1.101v5.654c0 .053.007.101.078.13l.957.372-.43 1.122-1.123-.475c-.425-.18-.574-.44-.574-.993",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.248 13.732a1.75 1.75 0 0 1-.132-2.656l-.712-1.153a3.089 3.089 0 0 0 .172 4.976l.672-1.167z",
    fill: "#009DD7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.73 10.697a1.754 1.754 0 0 1 2.235 1.032l1.362-.113a3.093 3.093 0 0 0-4.166-2.133l.569 1.214z",
    fill: "#FFF200"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.075 12.433a1.755 1.755 0 0 1-2.18 1.616l-.534 1.237a3.09 3.09 0 0 0 4.05-2.811l-1.336-.042z",
    fill: "#E33206"
  }));
};

Elo24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Elo32 = function Elo32(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v16a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.059 8.777a3 3 0 0 1 .935-.147c1.426 0 2.617.992 2.89 2.312l2.02-.404c-.463-2.243-2.485-3.93-4.91-3.93a5.12 5.12 0 0 0-1.59.252l.655 1.917z",
    fill: "#FFCA05"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.712 15.275 1.383-1.53a2.885 2.885 0 0 1-1.007-2.185c0-.87.389-1.65 1.006-2.184l-1.383-1.53A4.901 4.901 0 0 0 3 11.56c0 1.479.662 2.806 1.712 3.715z",
    fill: "#00A4DF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.884 12.18c-.274 1.319-1.463 2.31-2.888 2.31-.318 0-.634-.05-.936-.148l-.655 1.919a5.12 5.12 0 0 0 1.59.252c2.423 0 4.444-1.686 4.91-3.927l-2.021-.407z",
    fill: "#EE4123"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.627 13.187-.002.002-.057-.039a1.62 1.62 0 0 1-.747.627c-.617.27-1.189.2-1.6-.161l-.037.058c0-.001 0-.002-.002-.002l-.7 1.053c.174.122.36.224.557.306.774.324 1.565.309 2.345-.032a2.89 2.89 0 0 0 1.31-1.095l-1.067-.717zM16.44 10.59c-.652.28-.988.895-.92 1.616l2.762-1.194c-.474-.561-1.092-.747-1.842-.422zm-1.834 3.207a3.608 3.608 0 0 1-.21-.405 2.987 2.987 0 0 1-.064-2.25c.296-.81.86-1.43 1.591-1.745.918-.397 1.933-.319 2.813.206.56.322.955.82 1.256 1.522.039.09.072.186.105.268l-5.49 2.403zm7.41-5.95V13.7l.906.368-.514 1.207-1-.418a1.137 1.137 0 0 1-.493-.416 1.311 1.311 0 0 1-.193-.726V7.846h1.294zm2.347 4.361a1.66 1.66 0 0 0 .563 1.248l-.929 1.042a3.055 3.055 0 0 1-1.025-2.291A3.055 3.055 0 0 1 24 9.918l.93 1.041a1.659 1.659 0 0 0-.567 1.25zm1.652 1.662c.798 0 1.464-.568 1.62-1.324l1.364.28a3.05 3.05 0 0 1-3.952 2.283l.444-1.325c.165.055.341.085.524.085zm.004-4.718A3.05 3.05 0 0 1 29 11.602l-1.364.277a1.655 1.655 0 0 0-2.142-1.244l-.44-1.327a3.03 3.03 0 0 1 .965-.156z",
    fill: "#fff"
  }));
};

Elo32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Elo24,
  '32': Elo32
};
export var Elo = function Elo(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Elo' icon. Please use one of the available sizes: '24', '32'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};